<template>

    <q-card>

        <q-card-section>
            <div class="text-subtitle1 q-pb-sm row items-center">
                <q-icon name="mdi-account-plus" size="sm" class="q-mr-xs" />
                Account Registration
            </div>
            <p class="text-caption">Your information will not be shared - see our <router-link to="/privacy">Privacy Policy</router-link> for details.</p>
            <q-form @submit="onSubmit"
                    @reset="onReset"
                    autocomplete="off"
                    class="q-col-gutter-md q-mt-md">

                <q-input outlined dense
                         label="E-mail" stack-label
                         autocomplete="on" name="email"
                         :loading="getEmailAvailablePending"
                         :error-message="isEmailAvailableErrorMessage"
                         :error="!isEmailAvailable"
                         @change="checkEmailAvailable()"
                         type="email"
                         v-model.trim="form.email"
                         :rules="[ val => $v.form.email.required || 'Email is required', val => $v.form.email.email || 'Not a valid email format'  ]"
                         maxlength="250"
                         hide-bottom-space />

                <q-input outlined dense
                         label="Confirm E-mail" stack-label
                         autocomplete="on" name="email"
                         type="email"
                         v-model.trim="form.confirmEmail"
                         :rules="[ val => $v.form.confirmEmail.required || 'Confirm email is required', val => $v.form.confirmEmail.email || 'Not a valid email format', val => $v.form.confirmEmail.sameAsEmail || 'Emails must be identical'  ]"
                         maxlength="250"
                         hide-bottom-space />

                <q-input outlined dense
                         label="Password" stack-label
                         autocomplete="current-password" name="password"
                         v-model="form.password"
                         :type="isPwd ? 'password' : 'text'"
                         :rules="[ val => $v.form.password.required || 'Password is required' , val => $v.form.password.minLength || `Password must have at least ${$v.form.password.$params.minLength.min} letters`]"
                         hide-bottom-space>
                    <template v-slot:append>
                        <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                class="cursor-pointer"
                                color="grey-6" size="0.9em"
                                @click="isPwd = !isPwd" />
                    </template>
                </q-input>

                <q-input outlined dense
                         label="Confirm Password" stack-label
                         autocomplete="current-password" name="password"
                         v-model="form.confirmPassword"
                         :type="isPwd ? 'password' : 'text'"
                         :rules="[ val => $v.form.confirmPassword.sameAsPassword || 'Confirmation password does not match' ]"
                         hide-bottom-space>
                    <template v-slot:append>
                        <q-icon :name="isPwd ? 'mdi-eye-off' : 'mdi-eye'"
                                class="cursor-pointer"
                                color="grey-6" size="0.9em"
                                @click="isPwdConfirm = !isPwdConfirm" />
                    </template>
                </q-input>

                <div class="text-subtitle1 row items-center">
                    User Profile
                </div>
                <div class="row q-col-gutter-md">
                    <div class="col-xs-12 col-sm-6">
                        <q-input outlined dense
                                 label="First Name" stack-label
                                 autocomplete="on" name="firstName"
                                 v-model.trim="form.firstName"
                                 :rules="[ val => $v.form.firstName.required || 'First name is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <q-input outlined dense
                                 label="Last Name" stack-label
                                 autocomplete="on" name="lastName"
                                 v-model.trim="form.lastName"
                                 :rules="[ val => $v.form.lastName.required || 'Last name is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                </div>
                <q-input outlined dense
                         label="Company" stack-label
                         autocomplete="on" name="company"
                         v-model.trim="form.company"
                         maxlength="100"
                         hide-bottom-space />
                <q-input outlined dense
                         label="Website" stack-label
                         autocomplete="on" name="website"
                         v-model.trim="form.website"
                         maxlength="50"
                         hide-bottom-space />

                <div class="row q-col-gutter-md">
                    <div class="col-7">
                        <q-input outlined dense
                                 label="Phone" stack-label
                                 autocomplete="on" name="phone"
                                 v-model.trim="form.phone"
                                 :rules="[ val => $v.form.phone.required || 'Phone number is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                    <div class="col-5">
                        <q-input outlined dense
                                 label="Ext." stack-label
                                 autocomplete="on" name="extension"
                                 v-model.trim="form.extension"
                                 type="tel"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                </div>
                <q-input outlined dense
                         label="Address" stack-label
                         autocomplete="on" name="address"
                         v-model.trim="form.address"
                         :rules="[ val => $v.form.address.required || 'Street address is required' ]"
                         maxlength="200"
                         hide-bottom-space />
                <div class="row q-col-gutter-md">
                    <div class="col-7">
                        <q-input type="hidden" name="Country_hidden_input" label="Country Hidden Input" style="display: none;" />
                        <q-select outlined dense stack-label
                                  autocomplete="off" name="drop_down_input"
                                  @input="setProvStates()"
                                  v-model="form.country" :options="countries"
                                  :loading="getCountriesPending"
                                  option-value="key"
                                  option-label="value"
                                  @filter="countryFilterFn"
                                  use-input
                                  fill-input
                                  hide-selected
                                  input-debounce="0"
                                  :rules="[ val => $v.form.country.required || 'Country is required' ]"
                                  hide-bottom-space>
                            <template v-slot:prepend>
                                <span v-html="'<span>C&#8204;ountry</span>'" style="position: absolute; transform: translateY(-30%) scale(0.75); font-size: 14px; top: 7px; left: 5px;" />
                            </template>
                        </q-select>
                    </div>
                    <div class="col-5">
                        <q-input outlined dense
                                 label="Postal" stack-label
                                 autocomplete="on" name="postal"
                                 v-model.trim="form.postal"
                                 :rules="[ val => $v.form.postal.required || 'Postal is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                </div>
                <div class="row q-col-gutter-md">
                    <div class="col-7">
                        <q-input outlined dense
                                 label="City" stack-label
                                 autocomplete="on" name="city"
                                 v-model.trim="form.city"
                                 :rules="[ val => $v.form.city.required || 'City is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                    <div class="col-5">
                        <q-input type="hidden" name="ProvState_hidden_input" label="Prov/State Hidden Input" style="display: none;" />
                        <q-select v-if="!isCountryOther"
                                  outlined dense stack-label
                                  autocomplete="off" name="drop_down_input"
                                  :disable="!form.country"
                                  v-model="form.provState" :options="provStates"
                                  :loading="getProvincesPending || getStatesPending"
                                  option-value="key"
                                  option-label="value"
                                  @filter="provStateFilterFn"
                                  use-input
                                  fill-input
                                  hide-selected
                                  input-debounce="0"
                                  :rules="[ val => $v.form.provState.required || 'State/Prov is required' ]"
                                  hide-bottom-space>
                            <template v-slot:prepend>
                                <span v-html="'<span>S&#8204;tate/P&#8204;rov</span>'" style="position: absolute; transform: translateY(-30%) scale(0.75); font-size: 14px; top: 7px; left: 5px;" />
                            </template>
                        </q-select>
                        <q-input v-else
                                 outlined dense
                                 label="State/Prov" stack-label
                                 autocomplete="on" name="provState"
                                 v-model.trim="form.provState"
                                 :rules="[ val => $v.form.provState.required || 'State/Prov is required' ]"
                                 maxlength="50"
                                 hide-bottom-space />
                    </div>
                </div>

                <div class="row q-col-gutter-sm">
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn :label="postNewAccountPending ? 'Creating..' : 'Create Account'"
                               type="submit" color="primary" class="full-width" />
                    </div>
                    <div class="col-xs-12 col-sm-auto">
                        <q-btn label="Reset" type="reset" color="primary" flat class="full-width" />
                    </div>
                </div>
            </q-form>
        </q-card-section>

        <q-inner-loading :showing="postNewAccountPending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
    </q-card>
</template>
<script>
    import { required, minLength, sameAs, email } from 'vuelidate/lib/validators'
    import { mapState } from 'vuex'

    export default {
        name: 'create-account',
        props: {
            returnUrl: {
                default: '',
                type: String
            },
        },
        data() {
            return {
                isPwd: true,
                isPwdConfirm: true,
                isCountryOther: false,
                isEmailAvailable: true,
                isEmailAvailableErrorMessage: '',
                newAccountId: '',
                form: {
                    firstName: '',
                    lastName: '',
                    company: '',
                    address: '',
                    city: '',
                    provState: '',
                    country: '',
                    postal: '',
                    phone: '',
                    extension: '',
                    email: '',
                    confirmEmail: '',
                    website: '',
                    password: '',
                    confirmPassword: ''
                },
                countries: [],
                provStates: [],
            }
        },
        validations: {
            form: {
                firstName: { required },
                lastName: { required },
                address: { required },
                city: { required },
                provState: { required },
                country: { required },
                postal: { required },
                phone: { required },
                email: { required, email },
                confirmEmail: { required, email, sameAsEmail: sameAs('email') },
                password: {
                    required,
                    minLength: minLength(8)
                },
                confirmPassword: {
                    sameAsPassword: sameAs('password')
                }
            }
        },
        methods: {
            countryFilterFn(val, update, abort) {
                update(() => {
                    if (val === '') {
                        this.countries = this.getCountriesData
                    }
                    else {
                        const needle = val.toLowerCase()
                        this.countries = this.getCountriesData?.filter(c => c.value.toString().toLowerCase().indexOf(needle) > -1)
                    }
                })
            },
            provStateFilterFn(val, update, abort) {
                update(() => {
                    if (val === '') {
                        if (this.form.country) {
                            if (this.form.country?.key == 0)
                                this.provStates = this.getStatesData
                            else if (this.form.country?.key == 1)
                                this.provStates = this.getProvincesData
                        }
                    }
                    else {
                        const provStateOptions = this.provStates
                        const needle = val.toLowerCase()
                        this.provStates = provStateOptions?.filter(c => c.value.toString().toLowerCase().indexOf(needle) > -1)
                    }
                })
            },
            setProvStates() {
                if (this.form.country) {
                    this.form.provState = ''
                    if (this.form.country?.key == 0) {
                        this.isCountryOther = false
                        this.provStates = this.getStatesData
                    }
                    else if (this.form.country?.key == 1) {
                        this.isCountryOther = false
                        this.provStates = this.getProvincesData
                    }
                    else this.isCountryOther = true
                }

            },
            checkEmailAvailable() {
                if (this.form.email) {
                    this.$store.dispatch('getEmailAvailable', this.form.email).then(() => {
                        if (typeof this.getEmailAvailableData !== 'undefined') {
                            this.isEmailAvailable = this.getEmailAvailableData
                            if (!this.isEmailAvailable)
                                this.isEmailAvailableErrorMessage = 'Email has already been taken'
                        }
                    })
                }
            },
            setupAccountModel() {
                const accountModel = {
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    company: this.form.company,
                    address: this.form.address,
                    city: this.form.city,
                    provState: this.form.provState?.value ?? this.form.provState,
                    country: this.form.country?.key,
                    postal: this.form.postal,
                    phone: this.form.phone,
                    extension: this.form.extension,
                    email: this.form.email,
                    confirmEmail: this.form.confirmEmail,
                    website: this.form.website,
                    password: this.form.password,
                    confirmPassword: this.form.confirmPassword,
                }
                return accountModel
            },

            postNewAccount() {
                this.$store.dispatch('postNewAccount', this.setupAccountModel()).then(() => {
                    this.newAccountId = this.postNewAccountData
                    this.returnToLogin();
                })
            },
            async getData() {
                await this.$store.dispatch('getCountries').then(() => {
                    this.countries = this.getCountriesData
                })
                await this.$store.dispatch('getCanadianProvinces')
                await this.$store.dispatch('getAmericanStates')
            },
            onSubmit() {
                this.$v.form.$touch()
                if (this.hasFormError) return
                this.postNewAccount()
            },

            onReset() {
                this.isCountryOther = false
                this.isEmailAvailable = true
                this.isEmailAvailableErrorMessage = ''
                this.newAccountId = ''
                this.form = {
                    firstName: '',
                    lastName: '',
                    company: '',
                    address: '',
                    city: '',
                    provState: '',
                    country: '',
                    postal: '',
                    phone: '',
                    extension: '',
                    email: '',
                    confirmEmail: '',
                    website: '',
                    password: '',
                    confirmPassword: '',
                }
            },
            returnToLogin() {
                if (this.returnUrl) {
                    this.$router.push({
                        path: this.returnUrl,
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }
                else {
                    this.$router.push({
                        path: '/',
                        query: { login: true },
                    }).then(() => {
                        window.location.reload();
                    });
                }
            },
        },
        computed: {
            hasFormError() {
                if (this.$v.form.$pending || this.$v.form.$error || this.$v.form.$invalid)
                    return true
                if (!this.isEmailAvailable)
                    return true
                return false
            },
            ...mapState([
                'postNewAccountPending',
                'postNewAccountData',

                'getCountriesPending',
                'getCountriesData',

                'getProvincesPending',
                'getProvincesData',

                'getStatesPending',
                'getStatesData',

                'getEmailAvailablePending',
                'getEmailAvailableData',
            ]),
        },
        created() {
            this.getData().then(() => {

            })
        },

    }
</script>
<style>
    .q-field__native {
        padding-top: 14px;
        padding-bottom: 2px;
    }

    .q-field__prepend {
        padding: 0 !important;
    }
</style>
